"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.whoAmIState = exports.showLeaderReviewDialogState = exports.paymentMethodDialogState = exports.paymentDetailDeliveryState = exports.paymentDetailState = void 0;
const recoil_1 = require("recoil");
const functions_1 = require("@/common/functions");
const i18next_1 = __importDefault(require("i18next"));
const functions_2 = require("./functions");
const paymentDetailDataPromise = (0, functions_2.getPaymentDetailData)();
exports.paymentDetailState = (0, recoil_1.atom)({
    key: 'paymentDetailState',
    default: paymentDetailDataPromise,
});
exports.paymentDetailDeliveryState = (0, recoil_1.atom)({
    key: 'paymentDetailDeliveryState',
    default: paymentDetailDataPromise.then(data => {
        const { user_id, room_delivery_region: region, order_delivery: default_delivery, second_customvalue, 
        // user_second_customvalue,
        room_second_custom, waybill, } = data;
        const isForceComplete = !!(waybill === null || waybill === void 0 ? void 0 : waybill.name);
        return {
            user_id,
            region,
            default_delivery,
            second_customvalue: isForceComplete ? i18next_1.default.t('없음') : second_customvalue,
            room_second_custom,
        };
    }),
});
exports.paymentMethodDialogState = (0, recoil_1.atom)({
    key: 'paymentMethodDialogState',
    default: { showDialog: false, showPaypalDialog: false, payMethod: 'card' },
});
exports.showLeaderReviewDialogState = (0, recoil_1.atom)({
    key: 'showLeaderReviewDialogState',
    default: false,
});
const whoAmIDataPromise = (0, functions_1.getWhoAmI)();
exports.whoAmIState = (0, recoil_1.atom)({
    key: 'whoAmIState',
    default: whoAmIDataPromise,
});
